import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { CrossSvg, HamburgerSvg, PersonSvg, ProfileSvg } from '../../assets/svg';
import { api_urls } from '../../utils/api-urls';
import Logo from '../../assets/images/logo/logo.png';
import LogoSmall from '../../assets/images/logo/logo-small.png';
import { generateTokenByRequestPermission } from '../../config/firebase-config';
import * as AuthActions from '../../redux/actions/authAction';

Modal.setAppElement('#root');

const Header = () => {
    const navRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const location = useLocation();
    const specialRoutes = ["/muhurat", "/astrology-insights"];
    const isSpecialRoute = specialRoutes.some(route => location.pathname.startsWith(route));

    const { webLanguageData } = useSelector(state => state?.commonReducer);
    const { userCustomerDataById, userAstrologerDataById } = useSelector(state => state?.userReducer);

    const [shownav, setShownav] = useState(false);
    const [screenScroll, setScreenScroll] = useState(false);

    const userType = localStorage.getItem("user_type");

    //! Handle Resize and Scroll Event Listener 
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 500) {
                setShownav(false)
            }
        };

        const handleScroll = () => {
            if (window.scrollY > 60) setScreenScroll(true);
            else setScreenScroll(false);
        }

        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setShownav(false);
            }
        };

        window.addEventListener('resize', handleResize);
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('scroll', handleScroll);

        if (shownav) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('scroll', handleScroll);
        };
    }, [shownav]);

    // Todo : Astrolger Login Start
    const handleOpenLoginAstrologerModal = async () => {
        setShownav(false);
        if (!('Notification' in window)) {
            alert('This browser does not support desktop notifications.');
        } else if (Notification.permission === 'granted') {
            generateTokenByRequestPermission();
            dispatch(AuthActions.setAstrologerLoginModalOpen(true));
        } else if (Notification.permission === 'denied') {
            alert('You have blocked notifications. Please enable them in your browser settings.');
        } else if (Notification.permission === 'default') {
            const permission = await Notification.requestPermission();
        }
    };

    // Todo : Customer Login Start
    const handleOpenLoginCustomerModal = async () => {
        setShownav(false);
        if (!('Notification' in window)) {
            alert('This browser does not support desktop notifications.');
        } else if (Notification.permission === 'granted') {
            generateTokenByRequestPermission();
            dispatch(AuthActions.setCustomerLoginModalOpen(true));
        } else if (Notification.permission === 'denied') {
            alert('You have blocked notifications. Please enable them in your browser settings.');

        } else if (Notification.permission === 'default') {
            const permission = await Notification.requestPermission();
        }
    };

    function isWebView() {
        return (
            navigator.userAgent.includes('wv') || // Android WebView
            window.ReactNativeWebView // iOS/Android injected object
        );
    }

    const handleLink = async () => {
        if (isWebView()) {
            window.ReactNativeWebView?.postMessage(JSON.stringify({
                type: 'linking',
                payload: 'https://lifechangingastro.com/',
            }));
        } else {
            window.open('https://lifechangingastro.com/', '_blank');
        }
    };

    return (
        <>
            <header className={`fixed w-full max-w-[1700px] z-[1000] top-0 transition-all duration-300 text-[16px] font-normal shadow-md ${isSpecialRoute ? 'bg-[#0E1622] text-white border-b-2 border-yellow-400' : 'bg-white text-black'}         `}
            // className={`bg-white text-black fixed w-full max-w-[1700px] z-[1000] top-0 transition-all duration-300 text-[16px] font-normal shadow-md`}
            >
                <article>
                    <main className='flex flex-wrap justify-between items-center gap-5 relative z-10 px-5 py-5'>
                        {isSpecialRoute ?
                            <Link to={'/'} className="flex items-center space-x-2">
                                {/* <div className="w-8 h-8 bg-gradient-to-r from-cosmic-gold to-cosmic-glow rounded-full flex items-center justify-center">
                                    <Star className="w-5 h-5 text-primary-foreground" />
                                </div> */}
                                <img loading="lazy" className='h-12 max-lg:h-10' src={LogoSmall} alt="Acharya Luvbhushan" />
                                <span className="text-2xl font-bold text-cosmic-gold">Acharya Lavbhushan</span>
                            </Link>
                            :
                            <Link to={'/'} className='flex items-center gap-2'>
                                <img loading="lazy" className='h-12 max-lg:h-10' src={Logo} alt="Acharya Luvbhushan" />
                            </Link>
                        }

                        <nav className='flex gap-5 items-center max-lg:hidden'>
                            <NavLink to='/'>
                                {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Home</div>)}
                            </NavLink>

                            <NavLink to='/consultation-page'>
                                {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Consultation</div>)}
                            </NavLink>

                            <NavLink to='/reports'>
                                {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Reports</div>)}
                            </NavLink>

                            <div className='relative group cursor-pointer'>
                                <div className='hover:text-primary'>
                                    <a href='https://astrovastugurukull.com' target='_blank' rel='noopener noreferrer' className='block py-2 hover:text-primary'>Courses</a>
                                </div>
                            </div>
                            
                            {userAstrologerDataById ? <NavLink to='/register-puja' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Register Puja</NavLink> : <NavLink to='/book-puja' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Book Puja</NavLink>}
                            {/* <div onClick={() => handleLink()} className='hover:text-primary cursor-pointer'>Astroshop</div> */}

                            <NavLink to='/blog'>
                                {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Blog</div>)}
                            </NavLink>

                            <NavLink to='/about-us'>
                                {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>About Us</div>)}
                            </NavLink>

                            {!userCustomerDataById && !userAstrologerDataById && <div onClick={handleOpenLoginCustomerModal} className='flex items-center gap-1.5 cursor-pointer px-5 py-5.5 rounded-full'><div className='-mt-1'><div className='h-9 w-9 border border-secondary rounded-full flex items-center justify-center bg-secondary text-white'><PersonSvg h='20' w='20' /></div></div><div>Sign In</div></div>}

                            {userType === 'astrologer' && userAstrologerDataById &&
                                <div className='group text-black relative max-lg:hidden'>
                                    <div className='flex items-center gap-1 cursor-pointer'>{userAstrologerDataById?.profileImage ? <img loading="lazy" alt="" src={api_urls + userAstrologerDataById?.profileImage} className='h-10 w-10 rounded-full' /> : <ProfileSvg h='40' w='40' />}</div>

                                    <div className='font-normal absolute overflow-hidden top-[85px] right-0 bg-white w-56 h-0 rounded-lg group-hover:h-[400px] overflow-y-scroll custom-zero-scrollbar transition-all duration-500 ease-in group-hover:border-b-[5px] group-hover:border-t border-primary shadow-2xl'>
                                        <div className='flex flex-col items-center gap-1.5 py-5'>
                                            {userAstrologerDataById?.profileImage ? <img alt="" loading="lazy" src={api_urls + userAstrologerDataById?.profileImage} className='h-11 w-11 rounded-full' /> : <ProfileSvg h='40' w='40' />}
                                            <div className='text-[16px]'>{userAstrologerDataById?.astrologerName}</div>
                                            <div className='text-sm'>XXXXXX{userAstrologerDataById?.phoneNumber?.toString()?.substring(6, 10)}</div>
                                        </div>
                                        <div onClick={() => navigate('/astrologer-dashboard/my-account')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Account</div></div>
                                        <div onClick={() => navigate('/astrologer-dashboard/live-streaming')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Go Live</div> <div className='h-2 w-2 rounded-full bg-red-600 animate-ping'></div></div>
                                        <div onClick={() => navigate('/astrologer-dashboard/slot-management')} className='flex items-center gap-1 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Slot Management</p></div>
                                        <div onClick={() => navigate('/astrologer-dashboard/booking-management')} className='flex items-center gap-1 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Booking Management</p></div>
                                        <div onClick={() => navigate('/astrologer-dashboard/transaction-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Transaction History</div></div>
                                        <div onClick={() => navigate('/astrologer-dashboard/register-puja-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Register Puja History</div></div>
                                        <div onClick={() => navigate('/astrologer-dashboard/assigned-puja-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Assigned Puja History</div></div>
                                        <div onClick={() => dispatch(AuthActions.userLogout({ onComplete: () => navigate('/') }))} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Logout</div></div>
                                    </div>
                                </div>
                            }

                            {userType === 'customer' && userCustomerDataById &&
                                <div className='group text-black relative max-lg:hidden'>
                                    <div className='flex items-center gap-1 cursor-pointer rounded-full overflow-hidden'>{userCustomerDataById?.image ? <img alt="" loading="lazy" src={api_urls + 'uploads/' + userCustomerDataById?.image} className='h-10 w-10 object-contain rounded-full' /> : <ProfileSvg h='40' w='40' />}</div>

                                    <div className='font-normal absolute overflow-hidden top-[85px] right-0 bg-white w-56 h-0 rounded-lg group-hover:h-[400px] overflow-y-scroll custom-zero-scrollbar transition-all duration-500 ease-in group-hover:border-b-[5px] group-hover:border-t border-primary shadow-2xl'>
                                        <div className='flex flex-col items-center gap-1.5 py-5'>
                                            {userCustomerDataById?.image ? <img alt="" loading="lazy" src={api_urls + 'uploads/' + userCustomerDataById?.image} className='h-11 w-11 object-contain rounded-full bg-gray-100' /> : <ProfileSvg h='40' w='40' />}
                                            <div className='text-[16px]'>{userCustomerDataById?.customerName}</div>
                                            <div className='text-sm'>XXXXXX{userCustomerDataById?.phoneNumber?.toString()?.substring(6, 10)}</div>
                                        </div>
                                        <div onClick={() => navigate('/my-account?active-tab=update-profile')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Account</div></div>
                                        <div onClick={() => navigate('/my-booking')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Booking</p></div>
                                        <div onClick={() => navigate('/cart')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Cart</div></div>
                                        <div onClick={() => navigate('/transaction-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Transaction History</div></div>
                                        <div onClick={() => navigate('/my-order')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Order History</div></div>
                                        {/* <div onClick={() => handleLink()} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'>Astroshop</div> */}
                                        <div onClick={() => navigate('/book-puja')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Book Puja</div></div>
                                        <div onClick={() => navigate('/suggested-puja')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Suggested Puja</div></div>
                                        <div onClick={() => dispatch(AuthActions.userLogout({ onComplete: () => navigate('/') }))} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Logout</div></div>
                                    </div>
                                </div>
                            }
                        </nav>

                        <div onClick={() => setShownav(!shownav)} className={`cursor-pointer lg:hidden ${shownav == true && 'invisible'}`}><HamburgerSvg h={'30'} w={'30'} /></div>
                    </main>


                    <main ref={navRef} className={`pb-40 flex flex-col gap-5 p-5 absolute h-full bg-white text-black border-r border-primary shadow-lg top-0 z-50 min-h-[100vh] w-[80vw] transition-all duration-500 overflow-y-scroll ${shownav ? 'left-0' : 'left-[-200vw]'}`}>

                        <div onClick={() => setShownav(!shownav)} className='flex items-center justify-center gap-2 text-sm font-semibold cursor-pointer'>CLOSE <CrossSvg w={'20'} /></div>
                        <div className='text-center font-semibold text-sm'>WHAT ARE YOU LOOKING FOR?</div>


                        <div className='flex flex-col'>
                            {userType === 'customer' && userCustomerDataById && <>
                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/my-account?active-tab=update-profile' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Account</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/my-booking' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Booking</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/cart' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Cart</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/transaction-history' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Transaction History</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/my-order' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Order History</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/reports' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Reports</NavLink>
                                </div>

                                {/* <div onClick={() => handleLink()} className='flex items-center  border-b py-4 px-1  hover:text-primary cursor-pointer'>
                                    <div>Astroshop</div>
                                </div> */}

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/book-puja' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Book Puja</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/suggested-puja' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Suggested Puja</NavLink>
                                </div>
                            </>}

                            {userType === 'astrologer' && userAstrologerDataById && <>
                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/astrologer-dashboard/my-account' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Account</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/astrologer-dashboard/live-streaming' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}><div className='flex items-center gap-5'><span>Go Live</span> <div className='h-2 w-2 rounded-full bg-red-600 animate-ping'></div></div></NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/astrologer-dashboard/slot-management' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}><div className='flex gap-1 items-center'><p>Slot Management</p> </div></NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/astrologer-dashboard/booking-management' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Booking Management</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/astrologer-dashboard/transaction-history' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Transaction History</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/register-puja' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Register Puja</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/astrologer-dashboard/register-puja-history' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Register Puja History</NavLink>
                                </div>

                                <div className='flex items-center  border-b py-4 px-1'>
                                    <NavLink onClick={() => setShownav(!shownav)} to='/astrologer-dashboard/assigned-puja-history' className={({ isActive, isPending }) => isPending ? 'pending' : isActive ? 'text-primary' : 'text-black'}>Assigned Puja History</NavLink>
                                </div>
                            </>}

                            {userAstrologerDataById || userCustomerDataById ?
                                <>
                                    <div className='flex items-center gap-1  border-b py-4'>
                                        <div className='border-b-2 border-white'></div><div onClick={() => dispatch(AuthActions.userLogout({ onComplete: () => navigate('/') }))} className='cursor-pointer'>Logout</div>
                                    </div>
                                </>
                                :
                                <>
                                    <NavLink to='/' className="flex items-center gap-1  border-b py-4">
                                        {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Home</div>)}
                                    </NavLink>

                                    <NavLink to='/consultation-page' className="flex items-center gap-1  border-b py-4">
                                        {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Consultation</div>)}
                                    </NavLink>

                                    <NavLink to='/reports' className="flex items-center gap-1  border-b py-4">
                                        {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Reports</div>)}
                                    </NavLink>

                                    <div className='relative group cursor-pointer flex items-center gap-1  border-b py-4'>
                                        <div className='hover:text-primary'>
                                            <a href='https://astrovastugurukull.com' target='_blank' rel='noopener noreferrer' className='block py-2 hover:text-primary'>Courses</a>
                                        </div>
                                    </div>
                                    
                                    {userAstrologerDataById ? <NavLink to='/register-puja' className={({ isActive, isPending }) => isPending ? 'pending flex items-center gap-1  border-b py-4' : isActive ? 'text-primary flex items-center gap-1  border-b py-4' : 'hover:text-primary flex items-center gap-1  border-b py-4'}>Register Puja</NavLink> : <NavLink to='/book-puja' className={({ isActive, isPending }) => isPending ? 'pending flex items-center gap-1  border-b py-4' : isActive ? 'text-primary flex items-center gap-1  border-b py-4' : 'hover:text-primary flex items-center gap-1  border-b py-4'}>Book Puja</NavLink>}
                                    
                                    {/* <div onClick={() => handleLink()} className='hover:text-primary cursor-pointer flex items-center gap-1  border-b py-4'>Astroshop</div> */}

                                    <NavLink to='/blog' className="flex items-center gap-1  border-b py-4">
                                        {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>Blog</div>)}
                                    </NavLink>

                                    <NavLink to='/about-us' className="flex items-center gap-1  border-b py-4">
                                        {({ isActive, isPending }) => (<div className={isPending ? 'pending' : isActive ? 'text-primary' : 'hover:text-primary'}>About Us</div>)}
                                    </NavLink>

                                    <div className='flex items-center gap-1  border-b py-4'>
                                        <div className='border-b-2 border-white'></div><div onClick={handleOpenLoginCustomerModal} className='cursor-pointer'>Login as Customer</div>
                                    </div>
                                    <div className='flex items-center gap-1 border-b py-4'>
                                        <div className='border-b-2 border-white'></div><div onClick={handleOpenLoginAstrologerModal} className='cursor-pointer'>Login as Astrologer</div>
                                    </div>
                                </>
                            }
                        </div>
                    </main>
                </article>
            </header>

            {shownav && (<div className='fixed top-0 left-0 w-full h-full transition-all ease-in duration-300 bg-black bg-opacity-50 z-40' />)}
        </>
    )
}

export default Header;